module.exports = __webpack_public_path__ + "assets/logo_temp.96c0b848.svg";